import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type TcStatusKind = 'passed' | 'failed' | 'running' | 'draft' | 'blocked';

const ICON: Record<TcStatusKind, string> = {
  passed: 'check',
  failed: 'close',
  running: 'settings',
  draft: 'chevron_right',
  blocked: 'block',
};

@Component({
  selector: 'app-tc-status-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="tc-status-pill" [attr.data-kind]="kind()" data-testid="tc-status-pill" [attr.title]="title() || null">
      <span class="tc-status-pill__box" aria-hidden="true">
        <span class="tc-status-pill__icon material-icons">{{ icon() }}</span>
      </span>
      <span class="tc-status-pill__label">{{ label() }}</span>
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .tc-status-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    .tc-status-pill__box {
      width: 1.375rem;
      height: 1.375rem;
      border-radius: 0.375rem;
      display: grid;
      place-items: center;
      flex-shrink: 0;
      background: var(--to-slate-bg);

      .tc-status-pill[data-kind='passed'] & {
        background: var(--to-green-bg);
      }
      .tc-status-pill[data-kind='failed'] & {
        background: var(--to-red-bg);
      }
      .tc-status-pill[data-kind='running'] & {
        background: var(--to-blue-bg);
      }
      .tc-status-pill[data-kind='blocked'] & {
        background: var(--to-warn-bg);
      }
    }

    .tc-status-pill__icon {
      font-size: 0.8125rem;
      color: var(--to-slate-fg);

      .tc-status-pill[data-kind='passed'] & {
        color: var(--to-green-fg);
      }
      .tc-status-pill[data-kind='failed'] & {
        color: var(--to-red-fg);
      }
      .tc-status-pill[data-kind='running'] & {
        color: var(--to-blue-fg);
      }
      .tc-status-pill[data-kind='blocked'] & {
        color: var(--to-warn-fg);
      }
    }

    .tc-status-pill__label {
      font-size: 0.78125rem;
      font-weight: 600;
      color: var(--to-slate-fg);

      .tc-status-pill[data-kind='passed'] & {
        color: var(--to-green-fg);
      }
      .tc-status-pill[data-kind='failed'] & {
        color: var(--to-red-fg);
      }
      .tc-status-pill[data-kind='running'] & {
        color: var(--to-blue-fg);
      }
      .tc-status-pill[data-kind='blocked'] & {
        color: var(--to-warn-fg);
      }
    }
  `,
})
export class TcStatusPillComponent {
  readonly kind = input.required<TcStatusKind>();
  readonly label = input.required<string>();
  // Voller Tooltip-Text (inkl. Praefix wie "Letzte Ausführung: Bestanden") —
  // Aufrufer uebersetzt und reicht durch, kein `translate.instant` im Baustein
  // (NEX-1085 Review, sgraetz C1).
  readonly title = input<string>('');
  readonly icon = computed(() => ICON[this.kind()]);
}
